import {
  SET_SHOW_PRODUCT_STATUS_MODAL,
  SET_SINGLE_PRODUCT_DELETE_ROW_ID,
  SET_SINGLE_PRODUCT_IMAGE_UPLOAD_ROW_ID,
  SET_PRODUCT_LIST_ACTIVE_TAB,
  SET_PRODUCT_DETAIL_LOADING,
  SET_PRODUCT_DETAIL_DATA,
  SET_PRODUCT_DETAIL_ERROR,
  SET_PRODUCT_SAFETY_INFO_LOADING,
  SET_PRODUCT_SAFETY_INFO_DATA,
  SET_PRODUCT_SAFETY_INFO_ERROR,
  SET_IS_PRICE_AREA_UPDATE,
  SET_ACTIVE_INPUT_ID,
  SET_IS_PRICE_AREA_STATUS,
  SET_IS_PRICE_AREA_ERROR_MESSAGE,
  SET_PRODUCT_MODEL_CODE_LOADING,
  SET_PRODUCT_MODEL_CODE_ERROR,
  SET_PRODUCT_ADDITIONAL_INFO_LOADING,
  SET_PRODUCT_ADDITIONAL_INFO_ERROR,
  SET_PRODUCT_SALE_VARIANT_LOADING,
  SET_PRODUCT_SALE_VARIANT_ERROR,
  SET_PRODUCT_DESCRIPTION_LOADING,
  SET_PRODUCT_DESCRIPTION_ERROR
} from "./mutation-types";

import Request from "@/services/request";
import {
  SELLER_DASHBOARD_QUERY,
  DELETE_PRODUCTS_URL,
  PRODUCT_GROUP_SEARCH,
  PRODUCT_IMAGES,
  OPEN_FOR_SALE,
  TEMPLATE_DOWNLOAD,
  VALIDATE_UPLOAD,
  CONFIRM_UPLOAD,
  EXPORT_EXCEL,
  PRODUCT_UPDATE,
  PRODUCT_LIST_SUMMARY,
  CHANGE_APPROVAL_STATUS_URL,
  HISTORY_TAB_DOWNLOAD_URL,
  CONFIRM_DEAL_UPLOAD,
  SUBMIT_SINGLE_PRODUCT,
  PRODUCT_IMAGE_UPLOAD,
  PRODUCT_DESCRIPTION,
  PRODUCT_NUTRITIONS,
  MANUFACTURER_ORIGIN_INFO,
  SAFETY_INFO,
  SAFETY_INFO_UPLOAD,
  PRODUCT_NUTRITION_OPTIONS,
  PRODUCT_DETAIL,
  SUBMIT_SHIPMENT_TEMPLATE,
  SUBMIT_SALE_VARIANT_INFO,
  SUBMIT_DETAIL_DESCRIPTION,
  PRODUCT_SAFETY_INFO,
  PRODUCT_SAFETY_INFO_POST,
  PRODUCT_UPDATE_HISTORY,
  GET_PRODUCTS_BY_SAME_MODELCODE,
  GET_PRODUCTS_VARIANTS,
  PRODUCT_MODEL_CODE_POST,
  FEEDBACK_SUGGESTIONS_DESCRIPTION,
  PRODUCT_FEEDBACK_SUGGESTIONS,
  PRODUCT_FEEDBACK_SUGGESTIONS_TITLE,
  PRODUCT_FEEDBACK_SUGGESTIONS_ATTRIBUTES,
  UPDATE_ALL_PRODUCT_FIELDS,
} from '@/utils/enum/endpoints';

const request = new Request();

const getProductsModule = async ({ rootState }) => {
  try {
    const { sellerId } = rootState.auth.user;
    const { data } = await request.get(
      `${SELLER_DASHBOARD_QUERY}/${sellerId}?type=PRODUCTS_SUMMARY`,
    );
    return data.PRODUCTS_SUMMARY;
  } catch (data) {
    return Promise.reject(data);
  }
};

const deleteProducts = async (_, payload) => {
  try {
    const { productIds, tabParam } = payload;
    const res = await request.delete(DELETE_PRODUCTS_URL, {
      productIds,
      tabParam,
    });
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getProductInfo = async (_, { groupId }) => {
  try {
    const res = await request.post(PRODUCT_GROUP_SEARCH, {
      productGroupId: groupId,
      page: 0,
      size: 1000,
    });
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getProductImages = async (_, pimsId) => {
  try {
    const res = await request.get(PRODUCT_IMAGES.replace('{id}', pimsId));
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

const openForSale = async (
  _,
  { productGroupId, shipmentTemplate, productDetails },
) => {
  try {
    const requestPayload = {
      productGroupId,
      shipmentTemplate,
      productDetails,
    };

    const res = await request.post(OPEN_FOR_SALE, requestPayload);
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

const downloadProductTemplate = async (_, id) => {
  try {
    return await request.get(`${TEMPLATE_DOWNLOAD}?categoryId=${id}`);
  } catch (error) {
    return Promise.reject(error);
  }
};

const validateUpload = async (_, { file, type }) => {
  try {
    const { data } = await request.upload(
      VALIDATE_UPLOAD.replace('{type}', type.toLowerCase()),
      file,
    );
    return data;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const confirmUpload = async (_, id) => {
  try {
    const { data } = await request.post(`${CONFIRM_UPLOAD}/${id}`);
    return data;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const approveGIBSellerInfo = async ({ rootState }) => {
  try {
    const res = await request.post(
      rootState.common.checkGIBSellerInfoData.approveLink,
    );
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

// Actions for managing product modal states
const setShowProductStatusModal = ({ commit }, show) => {
  commit(SET_SHOW_PRODUCT_STATUS_MODAL, show);
};

const setSingleProductDeleteRowId = ({ commit }, rowId) => {
  commit(SET_SINGLE_PRODUCT_DELETE_ROW_ID, rowId);
};

const setSingleProductImageUploadRowId = ({ commit }, rowId) => {
  commit(SET_SINGLE_PRODUCT_IMAGE_UPLOAD_ROW_ID, rowId);
};

const setProductListActiveTab = ({ commit }, activeTab) => {
  commit(SET_PRODUCT_LIST_ACTIVE_TAB, activeTab);
};

// Product export and update functions
const requestExportExcel = async (_, payload) => {
  try {
    const requestPayload = Object.assign({}, payload);
    requestPayload.sellerStockCode = payload.stockCode || '';
    requestPayload.categoryIdList = payload.categoryIds || [];
    requestPayload.brandNameList = payload.brandName || [];
    requestPayload.gtin = payload.gtin || null;
    requestPayload.pimsId = payload.pimsId || null;
    requestPayload.productStatusList = payload.productStatus || [];
    requestPayload.saleStatus = payload?.saleStatus?.length
      ? payload.saleStatus[0]
      : null;
    delete requestPayload.stockCode;
    delete requestPayload.categoryIds;
    delete requestPayload.brandName;
    delete requestPayload.pageRequest;
    delete requestPayload.productStatus;

    const { data } = await request.post(
      `/endpoint-products/product-excel-export?tab=${payload?.tabParam}`,
      requestPayload,
    );
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
};

const requestExportExcelNew = async (_, payload) => {
  try {
    const requestPayload = Object.assign({}, payload);
    requestPayload.stockCode = payload.stockCode || null;
    requestPayload.categoryIds = payload.categoryIds || null;
    requestPayload.brandName = payload.brandName || null;
    requestPayload.gtin = payload.gtin || null;
    requestPayload.pimsId = payload.pimsId || null;
    requestPayload.productStatus = payload.productStatus || [];

    delete requestPayload.pageRequest;
    delete requestPayload.id;

    const { data } = await request.post(
      `${EXPORT_EXCEL}?tab=${payload?.tabParam}`,
      requestPayload,
    );
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
};

const getTabCount = async () => {
  try {
    const { data } = await request.get(`${PRODUCT_LIST_SUMMARY}`);
    return data;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const handleUpdate = async (
  { commit, rootState },
  { stockCode, stock, listPrice, salesPrice, id },
) => {
  try {
    const { sellerId } = rootState.auth.user;
    const { data } = await request.put(PRODUCT_UPDATE, {
      stockCode,
      stock,
      sellerId,
      listPrice: parseFloat(listPrice),
      salePrice: parseFloat(salesPrice),
      currencyType: 'TL',
    });
    commit(SET_IS_PRICE_AREA_UPDATE, true);
    commit(SET_ACTIVE_INPUT_ID, id);
    commit(SET_IS_PRICE_AREA_STATUS, true);
    setTimeout(() => {
      commit(SET_IS_PRICE_AREA_UPDATE, false);
      commit(SET_IS_PRICE_AREA_STATUS, null);
    }, 0);
    return Promise.resolve(data);
  } catch (e) {
    commit(SET_IS_PRICE_AREA_STATUS, false);
    commit(SET_IS_PRICE_AREA_ERROR_MESSAGE, e.data.message);
    return Promise.reject(e);
  }
};

const changeProductsApproveStatus = async (_, payload) => {
  try {
    const { productIds, productStatus, tabParam } = payload;
    const res = await request.put(CHANGE_APPROVAL_STATUS_URL, {
      productIds,
      productStatus,
      tabParam,
    });
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getProductsBySameModelCode = async (_, { productId, modelCode, categoryId, page, size }) => {
  try {
    const path = `${GET_PRODUCTS_BY_SAME_MODELCODE.replace("{productId}", productId)
      .replace("{modelCode}", modelCode)
      .replace("{categoryId}", categoryId)}&page=${page ?? 0}&size=${size ?? 25}`;

    const { data } = await request.get(path);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getProductVariants = async (_, payload) => {
  try {
    const params = {
      page: payload.page ?? 0,
      size: payload.size ?? 25,
    };

    const { data } = await request.get(
      GET_PRODUCTS_VARIANTS.replace("{productId}", payload.productId),
      Object.keys(params).length ? params : null,
    );
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getExportProductJobDetail = async (_, batchId) => {
  try {
    const res = await request.get(`${HISTORY_TAB_DOWNLOAD_URL}/${batchId}`);
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

const confirmDealUpload = async (
  _,
  { file, offerPeriodStart, offerPeriodEnd },
) => {
  try {
    const { data } = await request.upload(
      `${CONFIRM_DEAL_UPLOAD}?startDate=${offerPeriodStart}&finishDate=${offerPeriodEnd}`,
      file,
      {
        baseURL: '/sellerofficeapi/rest',
        headers: {
          Accept: 'application/json',
        },
      },
    );
    return data;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const getSubmitSingleProduct = async (_, payload) => {
  try {
    const { data } = await request.post(SUBMIT_SINGLE_PRODUCT, payload, {
      baseURL: '/selleroffice/rest',
      headers: {
        Accept: 'application/json',
      },
    });
    return data;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const getSubmittingShipmentTemplate = async (
  { commit },
  { productId, payload },
) => {
  try {
    const { data } = await request.put(
      SUBMIT_SHIPMENT_TEMPLATE.replace('{productId}', productId),
      payload,
      {
        baseURL: '/sellerofficeapi/rest',
        headers: {
          Accept: 'application/json',
        },
      },
    );

    commit(
      'common/SET_TOASTER_DATA',
      {
        type: 'success',
        title: 'Başarılı',
        description: 'Yaptığınız değişiklikler kaydedilmiştir.',
      },
      { root: true },
    );

    return data;
  } catch (error) {
    const errorMessage =
      error?.data?.errors?.[0]?.message ||
      'Teslimat şablonu güncellenirken bir hata oluştu.';

    commit(
      'common/SET_TOASTER_DATA',
      {
        type: 'error',
        title: 'Hata',
        description: errorMessage,
      },
      { root: true },
    );

    return Promise.reject(error);
  }
};

const getSubmittingSaleVariant = async ({ commit }, payload) => {
  commit(SET_PRODUCT_SALE_VARIANT_LOADING, true);
  commit(SET_PRODUCT_SALE_VARIANT_ERROR, null);
  try {
    const { data } = await request.patch(SUBMIT_SALE_VARIANT_INFO, payload, {
      baseURL: '/sellerofficeapi/rest',
      headers: {
        Accept: 'application/json',
      },
    });

    return data;
  } catch (error) {
    const errorMessage = error?.data?.errors?.[0]?.message || "Ek bilgi güncellenirken bir hata oluştu.";
    commit(SET_PRODUCT_SALE_VARIANT_ERROR, errorMessage);

    commit("common/SET_TOASTER_DATA", {
      type: "error",
      title: "Hata",
      description: errorMessage,
    }, { root: true });

    return Promise.reject(error);
  }
  finally {
    commit(SET_PRODUCT_SALE_VARIANT_LOADING, false);
  }
};

const uploadProductImages = async (_, { productImages }) => {
  try {
    const resp = await request.post(PRODUCT_IMAGE_UPLOAD, productImages, {
      baseURL: '/selleroffice/rest',
      headers: { Accept: 'application/json' },
      withCredentials: true,
    });
    return resp.data.images;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const submitDetailDescription = async ({ commit }, { productId, payload }) => {
  try {
    const { data } = await request.put(
      SUBMIT_DETAIL_DESCRIPTION.replace('{productId}', productId),
      payload,
      {
        baseURL: '/sellerofficeapi/rest',
        headers: {
          Accept: 'application/json',
        },
      },
    );
    commit(
      'common/SET_TOASTER_DATA',
      {
        type: 'success',
        title: 'Başarılı',
        description: 'Yaptığınız değişiklikler kaydedilmiştir.',
      },
      { root: true },
    );
    return data;
  } catch (error) {
    const errorMessage = error?.data?.errors?.[0]?.message || 'Ürün Açıklaması güncellenirken bir hata oluştu.';
    commit(
      'common/SET_TOASTER_DATA',
      {
        type: 'error',
        title: 'Hata',
        description: errorMessage,
      },
      { root: true },
    );
    return Promise.reject(error);
  }
};

const getProductDescription = async ({ commit }, { categoryId, skipLoading = false } = {}) => {
  if (!skipLoading) {
    commit(SET_PRODUCT_DESCRIPTION_LOADING, true);
    commit(SET_PRODUCT_DESCRIPTION_ERROR, null);
  }
  try {
    const { data } = await request.get(
      `${PRODUCT_DESCRIPTION}/${categoryId}`,
      null,
      {
        baseURL: '/selleroffice/rest',
        headers: {
          Accept: 'application/json',
        },
      },
    );
    return data;
  } catch (error) {
    const errorMessage = error?.data?.errors?.[0]?.message || 'Ürün Açıklaması güncellenirken bir hata oluştu.';
    if (!skipLoading) {
      commit(SET_PRODUCT_DESCRIPTION_ERROR , errorMessage);
      commit(
        'common/SET_TOASTER_DATA',
        {
          type: 'error',
          title: 'Hata',
          description: errorMessage,
        },
        { root: true },
      );
    }
    return Promise.reject(error);
  }
  finally {
    if (!skipLoading) {
      commit(SET_PRODUCT_DESCRIPTION_LOADING, false);
    }
  }
};

const getProductNutritions = async (_, { categoryId }) => {
  try {
    const res = await request.get(
      PRODUCT_NUTRITIONS.replace('{categoryId}', categoryId),
      null,
      {
        headers: {
          Accept: 'application/json',
        },
      },
    );
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getManufacturerOriginInfo = async () => {
  try {
    const response = await request.get(MANUFACTURER_ORIGIN_INFO, null, {
      headers: {
        Accept: 'application/json',
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};

const uploadSafetyInfo = async (_, formData) => {
  try {
    const response = await request.post(SAFETY_INFO_UPLOAD, formData, {
      headers: {
        Accept: 'application/json',
      },
      withCredentials: true,
    });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

const safetyInfo = async (_, productId) => {
  try {
    const res = await request.get(
      SAFETY_INFO.replace('{productId}', productId),
    );
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

const safetyInfoSubmit = async (_, { productId, payload }) => {
  try {
    const { data } = await request.post(
      PRODUCT_SAFETY_INFO_POST.replace('{productId}', productId),
      payload,
      {
        baseURL: '/sellerofficeapi/rest',
        headers: {
          Accept: 'application/json',
        },
      },
    );
    return data;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const submitProductDescriptionUpdateRequest = async (_, payload) => {
  try {
    const { data } = await request.post(
      FEEDBACK_SUGGESTIONS_DESCRIPTION,
      payload,
      {
        baseURL: '/sellerofficeapi/rest',
        headers: {
          Accept: 'application/json',
        },
      },
    );
    return data;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const getProductNutritionOptions = async () => {
  try {
    const response = await request.post(
      PRODUCT_NUTRITION_OPTIONS,
      ['nutritional-values'],
      {
        headers: {
          Accept: 'application/json',
        },
      },
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

async function fetchProductDetail({ commit }, pid) {
  if (!pid) {
    commit(SET_PRODUCT_DETAIL_ERROR, 'Product ID is required');
    return;
  }

  commit(SET_PRODUCT_DETAIL_ERROR, null);

  try {
    const response = await request.get(`${PRODUCT_DETAIL}/${pid}`);

    commit(SET_PRODUCT_DETAIL_DATA, response.data);
    commit(SET_PRODUCT_DETAIL_LOADING, false);

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch product detail';
    commit(SET_PRODUCT_DETAIL_ERROR, errorMessage);

    return {
      success: false,
      error: errorMessage,
    };
  }
}

const postProductAdditionalInfo = async (
  { commit },
  { productId, payload },
) => {
  commit(SET_PRODUCT_ADDITIONAL_INFO_LOADING, true);
  commit(SET_PRODUCT_ADDITIONAL_INFO_ERROR, null);

  try {
    const { data } = await request.patch(
      `/products/${productId}/additional-info`,
      payload,
      {
        baseURL: '/sellerofficeapi/rest',
        headers: {
          Accept: 'application/json',
        },
      },
    );

    commit(
      'common/SET_TOASTER_DATA',
      {
        type: 'success',
        title: 'Başarılı',
        description: 'Yaptığınız değişiklikler kaydedilmiştir.',
      },
      { root: true },
    );

    return data;
  } catch (error) {
    const errorMessage =
      error?.data?.errors?.[0]?.message ||
      'Ek bilgi güncellenirken bir hata oluştu.';
    commit(SET_PRODUCT_ADDITIONAL_INFO_ERROR, errorMessage);

    commit(
      'common/SET_TOASTER_DATA',
      {
        type: 'error',
        title: 'Hata',
        description: errorMessage,
      },
      { root: true },
    );

    return Promise.reject(error);
  } finally {
    commit(SET_PRODUCT_ADDITIONAL_INFO_LOADING, false);
  }
};

const getProductUpdateHistory = async (_, { page = 0, size = 10 } = {}) => {
  try {
    const { data } = await request.get(`${PRODUCT_UPDATE_HISTORY}`, {
      page,
      size,
    });
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const fetchProductSafetyInfo = async ({ commit }, pid) => {
  if (!pid) {
    console.error('Product ID is required for safety info');
    return Promise.reject({ message: 'Product ID is required' });
  }

  commit(SET_PRODUCT_SAFETY_INFO_LOADING, true);
  commit(SET_PRODUCT_SAFETY_INFO_ERROR, null);

  try {
    const { data } = await request.get(`${PRODUCT_SAFETY_INFO}/${pid}`, null, {
      headers: {
        Accept: 'application/json',
      },
    });

    commit(SET_PRODUCT_SAFETY_INFO_DATA, data);

    return data;
  } catch (error) {
    console.error('Failed to fetch product safety info:', error);
    const errorMessage =
      error?.data?.message ||
      error.message ||
      'Failed to fetch product safety info';
    commit(SET_PRODUCT_SAFETY_INFO_ERROR, errorMessage);
    return Promise.reject(error);
  } finally {
    commit(SET_PRODUCT_SAFETY_INFO_LOADING, false);
  }
};

const updateProductModelCode = async ({ commit }, { productId, modelCode }) => {
  commit(SET_PRODUCT_MODEL_CODE_LOADING, true);
  commit(SET_PRODUCT_MODEL_CODE_ERROR, null);

  try {
    const { data } = await request.put(
      PRODUCT_MODEL_CODE_POST.replace('{productId}', productId),
      {
        modelCode,
      },
      {
        baseURL: '/sellerofficeapi/rest',
        headers: {
          Accept: 'application/json',
        },
      },
    );

    commit(
      'common/SET_TOASTER_DATA',
      {
        type: 'success',
        title: 'Başarılı',
        description: 'Yaptığınız değişiklikler kaydedilmiştir.',
      },
      { root: true },
    );

    return data;
  } catch (error) {
    const errorMessage =
      error?.data?.errors?.[0]?.message ||
      'Model kodu güncellenirken bir hata oluştu.';
    commit(SET_PRODUCT_MODEL_CODE_ERROR, errorMessage);

    commit(
      'common/SET_TOASTER_DATA',
      {
        type: 'error',
        title: 'Hata',
        description: errorMessage,
      },
      { root: true },
    );

    return Promise.reject(error);
  } finally {
    commit(SET_PRODUCT_MODEL_CODE_LOADING, false);
  }
};

const postProductFeedbackSuggestionsImage = async (_, payload) => {
  try {
    const { data } = await request.post(
      PRODUCT_FEEDBACK_SUGGESTIONS.replace('{type}', 'images'),
      payload,
      {
        baseURL: '/sellerofficeapi/rest',
        headers: {
          Accept: 'application/json',
        },
      },
    );
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const submitTitleFeedbackSuggestion = async (_, payload) => {
  try {
    const { data } = await request.post(
      PRODUCT_FEEDBACK_SUGGESTIONS_TITLE,
      payload,
      {
        baseURL: '/sellerofficeapi/rest',
        headers: {
          Accept: 'application/json',
        },
      },
    );
    return data;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const postProductFeedbackSuggestionsUsc = async (_, payload) => {
  try {
    const { data } = await request.post(
      PRODUCT_FEEDBACK_SUGGESTIONS.replace('{type}', 'usc'),
      payload,
      {
        baseURL: '/sellerofficeapi/rest',
        headers: {
          Accept: 'application/json',
        },
      },
    );
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const submitAttributesFeedbackSuggestion = async (_, payload) => {
  try {
    const { data } = await request.post(
      PRODUCT_FEEDBACK_SUGGESTIONS_ATTRIBUTES,
      payload,
      {
        baseURL: '/sellerofficeapi/rest',
        headers: {
          Accept: 'application/json',
        },
      },
    );
    return data;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const updateAllProductFields = async (_, { productId, payload }) => {
  try {
    const { data } = await request.post(
      UPDATE_ALL_PRODUCT_FIELDS.replace("{productId}", productId),
      payload,
      {
        baseURL: "/sellerofficeapi/rest",
        headers: {
          Accept: "application/json",
        },
      }
    );

    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export default {
  getProductsModule,
  deleteProducts,
  getProductInfo,
  getProductImages,
  openForSale,
  downloadProductTemplate,
  validateUpload,
  confirmUpload,
  approveGIBSellerInfo,
  setShowProductStatusModal,
  setSingleProductDeleteRowId,
  setSingleProductImageUploadRowId,
  setProductListActiveTab,
  // Product Detail Actions
  fetchProductDetail,
  requestExportExcel,
  requestExportExcelNew,
  getTabCount,
  handleUpdate,
  changeProductsApproveStatus,
  getExportProductJobDetail,
  confirmDealUpload,
  getSubmitSingleProduct,
  uploadProductImages,
  getProductDescription,
  getProductNutritions,
  getManufacturerOriginInfo,
  safetyInfo,
  safetyInfoSubmit,
  uploadSafetyInfo,
  getProductNutritionOptions,
  submitDetailDescription,
  getSubmittingShipmentTemplate,
  getSubmittingSaleVariant,
  postProductAdditionalInfo,
  fetchProductSafetyInfo,
  getProductUpdateHistory,
  getProductsBySameModelCode,
  getProductVariants,
  updateProductModelCode,
  submitProductDescriptionUpdateRequest,
  postProductFeedbackSuggestionsImage,
  submitTitleFeedbackSuggestion,
  postProductFeedbackSuggestionsUsc,
  submitAttributesFeedbackSuggestion,
  updateAllProductFields
};
